import { render, staticRenderFns } from "./ButtonStart.vue?vue&type=template&id=64ece8a5&"
import script from "./ButtonStart.vue?vue&type=script&lang=js&"
export * from "./ButtonStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports